import { render, staticRenderFns } from "./PaginationNext.vue?vue&type=template&id=629ed971"
import script from "./PaginationNext.vue?vue&type=script&lang=js"
export * from "./PaginationNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports